import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'
import router from './router'
import '@fortawesome/fontawesome-free/css/all.css' // Ensure you are using css-loader
import Chat from 'vue-beautiful-chat'
// import VueSocketIO from 'vue-socket.io'


Vue.config.productionTip = false
Vue.use(Chat)
// Vue.use(new VueSocketIO({
//   debug: true,
//   connection: 'http://localhost:5000',
// }))

new Vue({
  iconfont: 'fa',
  router,
  render: h => h(App)
}).$mount('#app')
